import React from 'react';

const Load = () => {
  return (
    <h2 className='loadingText'>Loading...</h2>
  )
}

export default Load;

